import { Button, tk, Typography, zIndex } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;

  display: flex;
  flex-direction: column;

  background: ${tk('color_semantic_bg')};

  z-index: ${zIndex.modalOrMobilePopover};
`

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;

  display: flex;

  flex-direction: column;
  box-shadow: ${tk('shadow_md_bottom')};
`

interface HeaderProps extends React.PropsWithChildren, React.HTMLAttributes<HTMLDivElement> {}

const RawHeader = ({ children, ...rest }: HeaderProps) => <HeaderWrapper {...rest}>{children}</HeaderWrapper>

export const Header = styled(RawHeader)``

const TitleWrapper = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;

  ${Typography} {
    flex-basis: 100%;
    text-align: center;
  }
  ${Button} {
    position: absolute;
    right: 0;
  }
`

export function HeaderTitle({ children }: React.PropsWithChildren) {
  return <TitleWrapper>{children}</TitleWrapper>
}

export const HeaderContent = styled.div`
  display: block;
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: ${tk('spacing_md')};
`

export const Footer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${tk('spacing_sm')} ${tk('spacing_md')};

  box-shadow: ${tk('shadow_md_top')};

  > * {
    flex: 1;
  }
`
